var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlogLinkIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.8863,
    cy: 13.9996,
    r: 13.4996,
    stroke: "#6C584C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_267_2661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9784 10.3459L15.3507 8.97355C15.651 8.67319 16.0076 8.43494 16.4 8.27238C16.7925 8.10983 17.2131 8.02617 17.6379 8.02617C18.0626 8.02617 18.4832 8.10983 18.8757 8.27238C19.2681 8.43494 19.6247 8.67319 19.925 8.97355C20.2254 9.27391 20.4637 9.63049 20.6262 10.0229C20.7888 10.4154 20.8724 10.836 20.8724 11.2607C20.8724 11.6855 20.7888 12.1061 20.6262 12.4986C20.4637 12.891 20.2254 13.2476 19.925 13.5479L18.5527 14.9202M15.8081 17.6649L14.4358 19.0372C14.1354 19.3375 13.7789 19.5758 13.3864 19.7384C12.994 19.9009 12.5734 19.9846 12.1486 19.9846C11.2907 19.9846 10.468 19.6438 9.86141 19.0372C9.25481 18.4306 8.91402 17.6079 8.91402 16.75C8.91402 15.8921 9.25481 15.0694 9.86141 14.4628L11.2337 13.0905",
    stroke: "#6C584C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0586 15.8359L16.7181 12.1764",
    stroke: "#6C584C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_267_2661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.526,
    height: 15.526,
    fill: "white",
    transform: "translate(3.91016 14) rotate(-45)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogLinkIc);
export default __webpack_public_path__ + "static/media/blogLink_ic.ea8f4ffd5fced5a64aad19dc8c71abdd.svg";
export { ForwardRef as ReactComponent };